import * as React from "react";
import { Link } from "react-router-dom";
import { articles } from "data/posts/articles";

const groups = [...articles]
  .sort(
    (first, second) =>
      Date.parse(second.published) - Date.parse(first.published)
  )
  .reduce<Record<string, typeof articles>>((result, article) => {
    const year = article.published.match(/\b20\d{2}\b/)?.[0] || "Earlier";
    result[year] = [...(result[year] || []), article];
    return result;
  }, {});

const Posts = () => (
  <div className="editorial-page">
    <div className="archive">
      {Object.entries(groups)
        .sort(([first], [second]) => second.localeCompare(first))
        .map(([year, yearArticles]) => (
          <section className="archive__year" key={year}>
            <h2>{year}</h2>
            <ul className="dated-list">
              {yearArticles.map((article) => (
                <li key={article.link}>
                  <time>{article.published}</time>
                  {article.external ? (
                    <a href={article.link} target="_blank" rel="noreferrer">
                      {article.title}
                    </a>
                  ) : (
                    <Link to={article.link}>{article.title}</Link>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
    </div>
  </div>
);

export default Posts;
